package one.healthium.health_tools.ui

import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.catch
import kotlinx.coroutines.flow.combine
import kotlinx.coroutines.flow.update
import one.healthium.base.preferences.AppPreferences
import one.healthium.domain.user.UserInteractor
import one.healthium.healthKit.data.HealthKitHelper
import one.healthium.meal_plans.domain.MealPlanRepository
import one.healthium.ui.common.vm.BaseViewModel

internal class HealthToolsViewModel(
    userInteractor: UserInteractor,
    appPreferences: AppPreferences,
    mealPlanRepository: MealPlanRepository,
    healthKitHelper: HealthKitHelper,
) : BaseViewModel() {

    private val _state = MutableStateFlow(HealthToolsUiState())
    val state = _state.asStateFlow()

    init {
        combine(
            userInteractor.observeUser(),
            appPreferences.isMetricFlow,
            mealPlanRepository.getCurrentMealPlan().catch { emit(null) },
            healthKitHelper.getDailySteps(),
        ) { user, isMetric, currentMealPlan, dailySteps ->
            _state.update { state ->
                state.copy(
                    loading = false,
                    user = user,
                    isMetric = isMetric,
                    mealPlan = currentMealPlan,
                    dailySteps = dailySteps,
                )
            }
        }.launch()
    }
}